import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styled from 'styled-components';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { Header, Filter, ImagePreview, BidStatus } from './components';
import { Table, NoImagePlaceholder, VehicleOptions } from '../../../components';
import { VehicleDocs } from '../../../components/TableComponents';
import { AUCTION_END_FORMATTING } from '../../../constants';
import {
  filterVehicleSalesHistory,
  vehicleSalesHistorySetPage,
  listVehicleSalesHistory
} from '../../../actions/vehicles';
import { vehicleSalesHistoryCalculateStatus } from '../../../utils/statusCalculator';
import { MobileInfo } from '../VehicleList/components/MobileInfo';
import { Delimiter } from 'components/Table/common';
import { VehicleOptionsBlock } from '../VehicleSales/components/tableBlocks';

const StyledTableWrapper = styled.div`
  tr td:first-child {
    width: 80px;
  }

  @media (max-width: 800px) {
    thead tr {
      height: 0px;
    }
  }
`;

class VehicleSalesHistory extends Component {
  componentWillMount() {
    const { page, perPage, setPage, loadVehicles } = this.props;
    loadVehicles({ params: { limit: perPage, offset: page } });
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    setPage(page + 1);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  loadMore = () => {
    const { page, perPage, setPage, loadVehicles } = this.props;
    loadVehicles({ params: { limit: perPage, offset: page } });
    setPage(page + 1);
  };

  render() {
    const { page, setPage, perPage, currentFilter, loading, vehicles, vehiclesCount, history } = this.props;
    const buttons = [
      {
        title: 'View',
        color: 'secondary',
        handleClick: vehicle => history.push(`/vehicles/${vehicle.id}/details`)
      }
    ];

    const { width } = this.state;
    const columns =
      width > 800
        ? [
            { title: 'Vehicle Details', key: 'details' },
            { title: 'Status', key: 'status' },
            { title: 'Counter', key: 'counter' },
            { title: 'Auction', key: 'auction_end_date' },
            { title: 'Docs', key: 'docs' },
            { title: 'Actions', key: 'actions', cellClass: 'text-right' }
          ]
        : [
            { title: '', key: 'details' },
            { title: '', key: 'delimiter' },
            { title: '', key: 'mobile_info' },
            { title: '', key: 'actions' }
          ];

    return (
      <div>
        <Header />
        <div className="pageWrapper">
          <Filter perPage={perPage} setPage={setPage} />
          <StyledTableWrapper>
            <Table
              withMobileView
              columnsHead={columns}
              columnsData={vehicles}
              rowsCount={vehiclesCount}
              buttons={buttons}
              page={page}
              rowsPerPage={perPage}
              loadMore={this.loadMore}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              loading={loading}
              noDataText={
                !currentFilter && !loading
                  ? 'Once you list your first vehicle, you will see the sale status of that vehicle in this section.'
                  : ''
              }
            />
          </StyledTableWrapper>
        </div>
      </div>
    );
  }
}

const convertVehicles = state => {
  let vehicles = [];
  if (state.vehicles.salesHistoryData.rows) {
    vehicles = state.vehicles.salesHistoryData.rows.map(vehicle => {
      const isAdminCountered = vehicle.counters && vehicle.counters.amount_admin;

      const bidStatus = vehicleSalesHistoryCalculateStatus(vehicle);
      const counterComponent = isAdminCountered ? (
        <NumberFormat value={vehicle.counters.amount_admin} thousandSeparator prefix="$" displayType="text" />
      ) : (
        'N/A'
      );
      const formattedAuctionDate = vehicle.auction
        ? moment
            .utc(vehicle.auction.date_end)
            .local()
            .format(AUCTION_END_FORMATTING)
        : 'None';
      return {
        ...vehicle,
        image:
          vehicle.images[0] && vehicle.images[0].url_thumb ? (
            <ImagePreview vehicleId={vehicle.id} url={vehicle.images[0].url_thumb} />
          ) : (
            <NoImagePlaceholder />
          ),
        counter: counterComponent,
        status: <BidStatus vehicle={vehicle} status={bidStatus} />,
        details: <VehicleOptionsBlock currentVehicle={vehicle} />,
        auction_end_date: vehicle.auction
          ? moment
              .utc(vehicle.auction.date_end)
              .local()
              .format(AUCTION_END_FORMATTING)
          : 'None',
        docs: <VehicleDocs vehicle={vehicle} />,
        mobile_info: (
          <MobileInfo
            columns={[
              { label: 'Status:', value: <BidStatus vehicle={vehicle} status={bidStatus} /> },
              { label: 'Counter:', value: counterComponent },
              { label: 'Auction:', value: formattedAuctionDate },
              { label: 'Docs', value: <VehicleDocs vehicle={vehicle} /> }
            ]}
          />
        ),
        delimiter: <Delimiter />
      };
    });
  }
  return vehicles;
};

const currentFilter = formValueSelector('vehicleSalesHistoryFilterForm');

const mapStateToProps = state => ({
  vehicles: convertVehicles(state),
  vehiclesCount: state.vehicles.salesHistoryData.count,
  page: state.vehicles.salesHistoryData.page,
  perPage: state.vehicles.salesHistoryData.perPage,
  loading: state.vehicles.loading,
  auctionStatus: state.vehicles.auctionStatus,
  currentUser: state.user.user,
  currentFilter: currentFilter(state, 'status')
});

const mapDispatchToProps = dispatch => ({
  loadVehicles: payload => dispatch(listVehicleSalesHistory(payload).request),
  setPage: payload => dispatch(vehicleSalesHistorySetPage(payload)),
  filterVehicles: payload => dispatch(filterVehicleSalesHistory(payload).request)
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleSalesHistory);
